// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import TournamentStructure from '../tournamentStructure';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class TournamentCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      tournament_id : props.tournament_id,
      show_competition_id : props.competitions_id,
      view_type :props.view_type,
      initialView:props.initialView,
      games: [],
      mobile_no:'',
      categories: [],
      age_groups: [],
      genders: [],
      coordinaters:[],
      buddy_search_list:[],
      showStructure:false,
      competitions_id:'',
      competition_details : {
              tournament_id: props.tournament_id,
              game:'',
              category:'',
              gender:'',
              age_group:'',
              prize_and_perks:'',
              description:'',
              registration_amount:0,
              coordinaters:[],
              venue:[],
              start_date: moment(),
              end_date: moment(),
              registration_closed: moment(),
            },
      prev_competition_details:[],
      addNewCompetitionView:false,
      ShowCompetition:false,
      
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getCompetitionDetail = this.getCompetitionDetail.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleRegDate = this.handleRegDate.bind(this);
    this.handleStartDatePre = this.handleStartDatePre.bind(this);
    this.handleEndDatePre = this.handleEndDatePre.bind(this);
    this.handleRegDatePre = this.handleRegDatePre.bind(this);
  }


  componentDidMount() {
    
    this.getTournamentDetails();
    this.getCompetitionDetail();
    if(this.state.view_type =='addnew'){this.setState({addNewCompetitionView:true})}
    else{this.setState({ShowCompetition:true})}

  }

 
  getTournamentDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_competition/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState(
         { venues: data.venues,
           sub_categories: data.sub_categories,
           games: data.games,
           categories: data.categories,
           age_groups: data.age_groups, 
           genders: data.genders
         });
        })
       .catch(error => error);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['start_date'] = date
    this.setState({competition_details: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['end_date'] = date
    this.setState({competition_details: new_selected_one});
  }
  handleRegDate(date){
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    new_selected_one['registration_closed'] = date
    this.setState({competition_details: new_selected_one});
  }
  handleStartDatePre(date){
    var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
    new_selected_one['start_date'][1] = date
    this.setState({prev_competition_details: new_selected_one});
  }
  handleEndDatePre(date){
    var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
    new_selected_one['end_date'][1] = date
    this.setState({prev_competition_details: new_selected_one});
  }
  handleRegDatePre(date){
    var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
    new_selected_one['registration_closed'][1] = date
    this.setState({prev_competition_details: new_selected_one});
  }

  getCompetitionDetail(){
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/tournament/get_competition_detail_to_show/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.show_competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({prev_competition_details: data.competitions_list})
            if(data.competitions_list != null){
                  var start_date = moment(this.state.prev_competition_details.start_date[1])
                  var end_date = moment(this.state.prev_competition_details.end_date[1])
                  var registration_closed = moment(this.state.prev_competition_details.registration_closed[1])
                  console.log(start_date,end_date,registration_closed)
                  var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
                  new_selected_one['start_date'][1] = start_date
                  new_selected_one['end_date'][1] = end_date
                  new_selected_one['registration_closed'][1] = registration_closed
                  this.setState({prev_competition_details: new_selected_one});
                }})
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }

  postCreateCompetition() {
    var data = this.state.competition_details
    console.log(data)
    if(data.age_group == ''){data.age_group = this.state.age_groups[0].id}
    if(data.category == ''){data.category = this.state.categories[0][0]}
    if(data.gender == ''){data.gender = this.state.genders[0][0]}
    if(data.game == ''){data.game = this.state.games[0].pk}
    const url = `${getLocationOrigin()}/tournament/add_tournament_competition/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({  'tournament_id': data.tournament_id,
                                        'registration_amount':data.registration_amount,
                                        'prize_and_perks':data.prize_and_perks,
                                        'category':data.category,
                                        'game':data.game,
                                        'gender':data.gender,
                                        'age_group':data.age_group,
                                        'coordinaters':data.coordinaters,
                                        'venue':data.venue,
                                        'start_date':data.start_date,
                                        'end_date':data.end_date,
                                        'registration_closed':data.registration_closed,
                                        'description':data.description,
                        });

    console.log('Going to fetch');
     return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {  
        alert(response.message); 
          if(response.success){
          this.setState({competitions_id:response.competitions_id,showStructure:true,ShowCompetition:false,addNewCompetitionView:false});
          }
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
      //this.setState({showStructure:true,ShowCompetition:false,addNewCompetitionView:false});

  }

  getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.competition_details);
        new_selected_one.coordinaters.push(buddy_id)
        this.setState({competition_details: new_selected_one, search: false});
        this.state.coordinaters.push([buddy_id,name]);
    }
  setCordinater(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
        new_selected_one.coordinator.push([buddy_id,name])
        this.setState({prev_competition_details: new_selected_one, search: false});
  }

  removeCoordinater(name,coordinator_id){
        var new_selected_one =  Object.assign({}, this.state.competition_details);
        
        new_selected_one.coordinaters.pop(coordinator_id)
        this.setState({competition_details: new_selected_one, search: false});
        this.state.coordinaters.pop([coordinator_id,name]);
  }
  removeCoordinaterPrev(name,coordinator_id){
        var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
        
        new_selected_one.coordinater.pop(coordinator_id)
        this.setState({prev_competition_details: new_selected_one, search: false});
        this.state.coordinaters.pop([coordinator_id,name]);
  }

 
  handleChangeForNew(event){
    console.log(event.target.name,event.target.value)
    var name = event.target.name
    if(name== 'mobile_no'){
       this.setState({mobile_no:event.target.value})
    }
    else {
      
          var new_selected_one =  Object.assign({}, this.state.competition_details);
          new_selected_one[name] = event.target.value
          this.setState({competition_details: new_selected_one});
        
    }
  }
  handleMultiselect(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.competition_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({competition_details: new_selected_one});
  }
  handleMultiselectPrev(event) {
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.prev_competition_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
              if (options[i].selected) {
                ids.push([options[i].value,name]);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({prev_competition_details: new_selected_one});
  }

  handleChange(event,struct_id){
    var name = event.target.name
    var new_selected_one =   this.state.prev_competition_details;
    if(name == 'game' || name == 'age_groups' || name == 'gender' || name == 'category'){
          new_selected_one[name][0] = event.target.value
        }
    else{
          new_selected_one[name] = event.target.value
      }
  
    this.setState({prev_competition_details: new_selected_one}); 
  }
  postSaveCompetition(){
    var data = this.state.prev_competition_details;
    console.log(data)
    console.log("data collected")
    const url = `${getLocationOrigin()}/tournament/save_tournament_Competition/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({  'id':data.id,
                                        'tournament_id': this.state.tournament_id,
                                        'registration_amount':data.registration_amount,
                                        'prize_and_perks':data.prize_and_perks,
                                        'category':data.category[0],
                                        'game':data.game[0],
                                        'gender':data.gender[0],
                                        'age_group':data.age_groups[0],
                                        'coordinater':data.coordinator,
                                        'venue':data.venue,
                                        'start_date':data.start_date[1],
                                        'end_date':data.end_date[1],
                                        'registration_closed':data.registration_closed[1],
                                        'description':data.description,
                        });

    console.log('Going to fetch');
     return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          window.location.reload();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }


  deleteCompetition(){
        const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.prev_competition_details.id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => 
                {alert(data.message)
                window.location.reload()
              }
            )
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.postCreateCompetition();
    
  }
  toShowCompetitionView(){
    this.setState({ShowCompetition:!this.state.ShowCompetition,addNewCompetitionView:false})
  }
  toAddCompetitionView(){
    this.setState({addNewCompetitionView:!this.state.addNewCompetitionView,ShowCompetition:false})
  }
  render() {
    console.log(this.state);
    console.log("in render");
    return(
      <div>
      <div>
      {this.state.showStructure && 
                <TournamentStructure id={this.state.tournament_id} initialView={this.state.showStructure} competitions_id={this.state.competitions_id}/>
      }
      </div>
      {/*{ this.state.ShowCompetition && 
            <div style={styles.button_view} className="col-md-12">
                    <input className="button" type="button" value="Add Competition" onClick={() => {this.toAddCompetitionView()}} style={styles.input_button}/>
            </div>
            }
            { ! this.state.initialView && this.state.addNewCompetitionView &&
              <div style={styles.button_view} className="col-md-12">
                     <input type="button" value="Show Competition" style={styles.input_button} onClick={()=>{this.toShowCompetitionView()}}/>          
            </div>
            }*/}
      {this.state.ShowCompetition && 
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            Competition
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}> 
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game 
              </div>
              <select name="game" className="col-md-6"  style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChange(e)}}>
                {
                  this.state.games.map((x, index) => (
                  <option selected={this.state.prev_competition_details.game[0] == x.pk && x} key={x.pk} value={x.pk}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Category
              </div>
              <select name="category" className="col-md-6" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChange(e)}}>
                {
                  this.state.categories.map((category, index) => (
                  <option key={index} selected={this.state.prev_competition_details.category[0] == category[0] && category[0]} value={category[0]}>{category[1]}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Gender
              </div>
              <select name="gender" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChange(e)}}>
                {
                  this.state.genders.map((gender, index) => (
                  <option key={index} selected={this.state.prev_competition_details.gender[0] == gender[0] && gender[0]} value={gender[0]}>{gender[1]}</option>
                  ))
                }
              </select>
            </div>

            
           
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_groups" id="age_groups" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChange(e)}}>
                {
                  this.state.age_groups.map((age_group, index) => (
                  <option key={index} selected={this.state.prev_competition_details.age_groups[0] == age_group.id && age_group.id} value={age_group.id}>{age_group.name}</option>
                  ))
                }
              </select>
              
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={moment(this.state.prev_competition_details.start_date[1])} onChange={this.handleStartDatePre}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker selected={moment(this.state.prev_competition_details.end_date[1])} onChange={this.handleEndDatePre}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration End Date
              </div>
              <DatePicker selected={moment(this.state.prev_competition_details.registration_closed[1])} onChange={this.handleRegDatePre}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venues
              </div>
              <select name="venue" id="venue" className="col-md-6" style={styles.item_body} value={this.state.value} multiple={true}
                onChange={(e) =>{this.handleMultiselectPrev(e)}}>
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>
              
            </div>
            <div style={{marginTop:'10px',textAlign:'right'}} className="col-md-12">
                <small className="pull-right">* use &lt;Ctrl&gt; for multiple selection</small>
            </div>
            {this.state.prev_competition_details &&
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    Selected Coordinaters 
                </div>
                <div  className="col-md-6" style={{padding: '6px ',width:'60%',display:'flex',flexDirection:'column'}}>
                {this.state.prev_competition_details.coordinator.map((coordinator,index) =>
                  <div style={{display:'flex',flexDirection:'row'}}>
                  <div >{coordinator[1]}</div>
                  <div><input type="button" key={index} value="X" style={{'backgroundColor':"red"}} onClick={()=>{this.removeCoordinater(coordinator[0],coordinator[1])}} /> </div>
                  </div>
                  )}
                </div>
            </div>
            }
            <div style={styles.items} className="col-md-12" >
                        <div style={styles.item_header} className="col-md-6">
                            Search Coordinator
                        </div>
                        <div className="col-md-6 input-group">
                                <input type="text" name="mobile_no" className="col-md-10 form-control" 
                                placeholder="Search for.. " value={this.state.mobile_no} onChange={(e) =>{this.handleChangeForNew(e)}}/>
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                         </div>
                    </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setCordinater(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                        </div>
                    }</div>:''}
   

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Prize and Perks
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="prize_and_perks" defaultValue={this.state.prev_competition_details.prize_and_perks}
                onChange={(e) =>{ this.handleChange(e)}} />
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="description"  defaultValue={this.state.prev_competition_details.description}
                onChange={(e) =>{ this.handleChange(e)}} />
            </div>
             
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Amount
              </div>
             <input type="number" style={styles.input} name="registration_amount" className="required"  defaultValue={this.state.prev_competition_details.registration_amount}
                 onChange={(e) =>{ this.handleChange(e)}}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <div>
              <input className="button1" type="button" onClick={() => {this.postSaveCompetition()}} value="Save" style={styles.input_button}/>
              </div>
              {/*
              <div>
              <input type="button" className="button1" value="Cancel" style={styles.delete_button} onClick={()=>{this.toShowCompetitionView()}}/>
              </div>*/}
            </div>
            
          </form>
        </div>
      </div>
    
      }
      {this.state.addNewCompetitionView &&
      <div style={styles.container}>
      
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            Add Competition
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}> 
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game 
              </div>
              <select name="game" className="col-md-5"  style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.games.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Category
              </div>
              <select name="category" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.categories.map((format, index) => (
                  <option key={index} value={format[0]}>{format[1]}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Gender
              </div>
              <select name="gender" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.genders.map((format, index) => (
                  <option key={index} value={format[0]}>{format[1]}</option>
                  ))
                }
              </select>
            </div>

            
           
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group" id="age_group" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.age_groups.map((age_group, index) => (
                  <option key={index} value={age_group.id}>{age_group.name}</option>
                  ))
                }
              </select>
              
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.competition_details.start_date} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker selected={this.state.competition_details.end_date} onChange={this.handleEndDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration End Date
              </div>
              <DatePicker selected={this.state.competition_details.registration_closed} onChange={this.handleRegDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venues
              </div>
              <select name="venue" id="venue" className="col-md-5" style={styles.item_body} value={this.state.value} multiple={true}
                onChange={(e) =>{this.handleMultiselect(e)}}>
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>
              <small className="pull-right">* use &lt;Ctrl&gt; for multiple selection</small>
            </div>
            {this.state.coordinaters.length > 0 &&
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    Selected Coordinaters 
                </div>
                <div  className="col-md-6">
                {this.state.coordinaters.map((coordinator,index) =>
                  <div >{coordinator[1]} <input type="button" value="X" key={index} style={{'backgroundColor':"red"}} onClick={()=>{this.removeCoordinater(coordinator[0],coordinator[1])}} /> </div>
                  )}
                  </div>
            </div>
            }
            <div style={styles.items} className="col-md-12" >
                        <div style={styles.item_header} className="col-md-6">
                            Search Coordinator
                        </div>
                        <div className="col-md-5 input-group">
                                <input type="text" name="mobile_no" className="col-md-10" 
                                placeholder="Search for.. " value={this.state.mobile_no} onChange={(e) =>{this.handleChangeForNew(e)}}/>
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                         </div>
                    </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                            <div>
                            <RaisedButton
                            onClick={this.handleOpen}
                            label="Add"
                            style={{float:'right'}}
                            secondary={true}
                            />
                            <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.dialog_open_cust}
                            onRequestClose={this.handleClose}
                            >
                            <div>
                                <div style={styles.main_header} className="col-md-12">
                                <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Name
                                </div>
                                <input type="text" style={styles.input} name="cust_name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                </div>
                                <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                    value={this.state.mobile_no} onChange={this.handleChange}/>
                                </div>
                            </div>
                            </Dialog>
                        </div>
                        </div>
                    }</div>:''}
   

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Prize and Perks
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="prize_and_perks" placeholder="Enter Prize and Perks"
                onChange={(e) =>{ this.handleChangeForNew(e)}} />
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="description"  placeholder="Enter Competition Description"
                onChange={(e) =>{ this.handleChangeForNew(e)}} />
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Amount
              </div>
             <input type="number" style={styles.input} name="registration_amount" className="required" 
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>


            <div style={styles.button_submit} className="col-md-12">

              <input className="button" type="button" onClick={() => {this.postCreateCompetition()}} value="Create" style={styles.input_button}/>
                
            </div>
            
          </form>
        </div>
      </div>
    }
    </div>
    );
  }
}

export default TournamentCompetition;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/tournamentCompetition/index.js